// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__1ppCV","overflowing":"ReadFullNote_overflowing__3oOlF"};